define(function (require) {
    "use strict";

    var LE = require("app");

    var LobListFilters = [];

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        LobListFilters = [{
            name: "name",
            type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

            getFilterData: function () {
                var dataManager = LEUserManagement.getDataManager();
                var lobsCollection = dataManager.getData(dataManager.getEntities().LOB);
                var hasEntitiesTaggingByLobFeature = LE.sessionManager.hasEntitiesTaggingByLobFeature();

                var valuesArr = [];
                lobsCollection.each(function (lobModel) {
                    var lobAllowed = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isLobAllowedForUser, lobModel.id);
                    if (!hasEntitiesTaggingByLobFeature || lobAllowed) {
                        valuesArr.push({id: lobModel.getName(), value: lobModel.getName()});
                    }
                });
                return {
                    valuesArr: valuesArr,
                    placeholderText: LE.translator.translate("LEUserManagement.lobList.column.name.filter.placeholder")
                };
            }
        }];
    }

    LE.module("LEUserManagement", moduleDefinition);

    return LobListFilters;
});
